import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';

import { CustomTable, Text } from '../../../../shared/uiComponents';
import { useCheckPermission, useScreenWidth } from '../../../../shared/Helpers/hooks';
import { InsuranceAuthIcon } from '../../../../shared/Assets/svg/icons/InsuranceAuthIcon';
import { MobilePagination } from '../../../../shared/uiComponents/Table/pagination';
import { PERMISSIONS } from '../../../../App/constants';
import { TableBodyAdmin, headersAdmin } from './tableInfo';
import AddInsuranceAuthorization from './AddInsuranceAuthorization';
import { InsuranceAuthorizationMobileCard } from './mobileCard';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { getInsuranceAuthorizations } from '../../../../redux/State/clientSlice/insuranceAuthorizationSlice';

const AdminPanel = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();
	const [params] = useSearchParams();
	const { permissionGranted } = useCheckPermission(PERMISSIONS.INSURANCE_AUTHORIZATION.CREATE);

	const userId = useSelector((state) => state.account.user.id);
	const loading = useSelector((state) => state.authorization.loading);
	const authorization = useSelector((state) => state.authorization.allInsuranceAuthorizations);

	useEffect(() => {
		if (!clientId || !userId) return;
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';

		dispatch(getInsuranceAuthorizations({ clientId, page, pageSize }));
	}, [clientId, dispatch, userId, params]);

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	return (
		<>
			<div className="insuranceAuthorizationAdminPanelHeader">
				<div className="insuranceAuthorizationHeaderTitle">
					<div className="listHeaderIcon">
						<InsuranceAuthIcon />
					</div>
					<Text type="h6" fontWeight="semiBold" title="Insurance Authorization" />
				</div>
				{permissionGranted && <AddInsuranceAuthorization />}
			</div>

			{isMobile ? (
				<div className="insuranceAuthorizationMobileCardContainer">
					{authorization.query?.map((item) => (
						<InsuranceAuthorizationMobileCard item={item} key={item.id} />
					))}
					<MobilePagination data={authorization} />
				</div>
			) : (
				<CustomTable TableBody={TableBodyAdmin} headers={headersAdmin} data={authorization} loading={loading} />
			)}
		</>
	);
};

export default AdminPanel;
